module.exports = __webpack_public_path__ + "static/media/teachers.b4a04c21.jpeg";